import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { colors } from 'stylesheets';
import newTask from 'assets/img/more.svg';
import arrowRightMenu from 'assets/img/arrowRightMenu.svg';

export const Container = styled.div`
  z-index: 999;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${({ minimized }) => (minimized ? '8.2vw' : '224px')};
  max-width: ${({ minimized }) => (minimized ? '130px' : '224px')};
  box-shadow: ${({ minimized }) => (minimized ? '' : '0px 4px 20px rgba(0, 0, 0, 0.17)')};
  border-right: 1px solid ${colors.greyLighter};
  height: calc(100vh - 12px);
  background: ${colors.white};
  transition: 0.2s all ease;
`;

export const Nav = styled.nav`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const BtnNewTask = styled.button`
  margin-bottom: 12px;
  border-radius: 4px;
  span {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    margin-left: 30px;
  }
  width: ${({ minimized }) => (minimized ? '5.28vw' : '184px')};
  height: 40px;
  min-height: 40px;
  line-height: 24px;
  background: #f07e31 url(${newTask}) no-repeat
    ${({ minimized }) => (minimized ? 'center' : '18px')} 13px;
  background-size: 15px 15px;
  /* identical to box height, or 150% */
  align-items: center;
  transition: 0.2s all ease;
  padding: 0;
  font: inherit;
  outline: inherit;
  border: none;
  /* white */

  color: #ffffff;
`;

export const Line = styled.div`
  width: ${({ minimized }) => (minimized ? '72px' : '184px')};
  height: 1px;
  border: 1px solid ${({ minimized }) => (minimized ? '#fff' : '#eeeeee')};
  box-sizing: border-box;
  margin-bottom: 20px;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 10px;
  padding: 0px;

  & > li {
    text-align: center;
    list-style: none;
    margin-bottom: 10px;
  }
`;

export const A = styled(NavLink)`
  display: flex;
  width: 100%;
  height: 50px;
  text-decoration: none;
  position: ${({ islast }) => (islast ? 'absolute' : 'static')};
  bottom: ${({ islast }) => (islast ? '10px' : '0px')};
  &.active {
    > div {
      border-right: 3px solid ${colors.primary};
      div {
        background: ${colors.primary};
        mask: url(${props => props.svg}) no-repeat center;
        mask-size: contain;
      }
      span {
        color: ${colors.primary};
      }
    }
  }
  &:hover {
    text-decoration: none;
  }
`;

export const WrapItem = styled.div`
  transition: all 0.3s;
  display: flex;
  align-items: center;
  padding-left: ${({ minimized }) => (minimized ? '0px' : '40px')};
  justify-content: ${({ minimized }) => (minimized ? 'center' : '')};
  width: ${({ minimized }) => (minimized ? '8.1vw' : '222px')};
  max-width: ${({ minimized }) => (minimized ? '128px' : '222px')};
  height: 50px;
  border-right: 3px solid transparent;
  padding-top: 7px;
  & > span {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #a1a1a1;
    margin-left: 24px;
  }

  &:hover {
    div {
      background: ${colors.primary};
      mask-size: contain;
    }
    span {
      color: ${colors.primary};
    }
  }
`;

export const Icon = styled.div`
  width: 22px;
  height: 22px;
  background: #a1a1a1;
  mask: url(${props => props.svg}) no-repeat center;
  mask-size: contain;
  background-size: contain;
`;

export const ContentHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
`;

export const ContentUser = styled.div`
  margin-top: 20px;
  margin-bottom: 55px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: ${({ minimized }) => (minimized ? '0px' : '15px')};
  display: flex;
  flex-direction: ${({ minimized }) => (minimized ? 'column' : 'row')};
  justify-content: center;
  align-items: center;
  height: 72px;
  width: ${({ minimized }) => (minimized ? '5.28vw' : '184px')};
  min-width: 74px;
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  ${({ isOpen }) => isOpen && ' background-color: #e2e2e2'};
  &:hover {
    background-color: #e2e2e2;
  }
`;

export const ImageUser = styled.div`
  width: 45px;
  height: 45px;
  margin-top: 5px;
  display: flex;
  background: url(${props => props.src}) no-repeat center;
  background-size: cover;
  border-radius: 50%;
`;

export const InfoUser = styled.div`
  display: flex;
  padding-left: 20px;
  flex-direction: column;
  align-items: flex-start;
  height: ${({ minimized }) => (minimized ? '32px' : '100%')};
  width: 70%;
  min-width: ${({ minimized }) => (minimized ? '100%' : '90px')};
`;

export const TitleUser = styled.p`
  width: 100%;
  height: 50%;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  margin-top: 7px;
  margin-bottom: 5px;
  color: #565656;
  text-transform: capitalize;
`;

export const SubtitleUser = styled.p`
  width: 100%;
  height: 50%;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #565656;
`;

export const OpenMenu = styled.div`
  display: flex;
  margin-right: -15px;
  justify-content: flex-end;
  margin-top: 15px;
  width: 30px;
  height: 30px;
  background: url(${arrowRightMenu}) no-repeat center;
  background-size: 30px px;
  transform: ${({ minimized }) => (!minimized ? 'rotate(180deg)' : '')};
  cursor: pointer;
`;
